export default "__VITE_ASSET__CoYHLmEw__";